import React from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow';

interface TableBodyProps {
  tableHeader: Object;
  tableData: Object[];
  onRowClick: Function;
}


function TableBody({ tableHeader, tableData, onRowClick }: TableBodyProps) {
  return (
    <tbody>
      {tableData.map((row, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <TableRow key={idx} tableHeader={tableHeader} row={row} onClick={onRowClick} />
      ))}
    </tbody>
  );
}

TableBody.propTypes = {
  tableHeader: PropTypes.object.isRequired,
  tableData: PropTypes.array.isRequired,
  onRowClick: PropTypes.func.isRequired,
};

export default TableBody;
